import { Component, Input } from '@angular/core';

@Component({selector: 'app-statsbox',
  templateUrl: './statsbox.component.html',
  styleUrls: ['./statsbox.component.scss'],
  standalone: false,
})
export class StatsboxComponent {
  @Input() iconUrl: string = '';
  @Input() iconWidth: string | number = 32;
  @Input() title: string;
  @Input() value: string | number;

}
